module.exports = __webpack_public_path__ + "img/KingdomOfSaudiArabia.9e3b7296.png";